
import { defineComponent, onMounted } from "vue";
import AssessoreWithInstitute from "@/views/Pending/list/AssessoreWithInstitute.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "dashboard",
  components: {
    AssessoreWithInstitute,
  },
  data() {
    return {
      data: "",
    };
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Dashboard");
    });
  },
});
